module.exports = __webpack_public_path__ + "static/media/MD_TutorialSlides_10202020_19_Effects.3b924831.png";